import React from "react";
import { Link } from "react-router-dom";
import StarRating from "../individual/StarRating";
import { GiStarShuriken } from "react-icons/gi";
import { AiOutlineGoogle } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
import { RiInstagramFill } from "react-icons/ri";
import { BsLinkedin } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import useAuth from "../../Hooks/useAuth";

const Footer = () => {
  const {showDummyImage} = useAuth()
    const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-top-wrapper">
            <div className="footer-top-content-items">
              <div className="footer-top-content-item">
                <div className="bar-code-content">
                  <div className="bar-code">
                    <img src={require("../../assets/images/footer/bar_code.png")} alt='barCode' onError={({currentTarget},imageSize='200X200')=>showDummyImage({currentTarget},imageSize)}/>
                  </div>
                  <h6 className="scaner">Scane Here</h6>
                </div>
              </div>
              <div className="footer-top-content-item">
                <div className="download-user">
                  <h6>Download</h6>
                  <p>Our Mobile App</p>
                  <div className="app-users">
                    {
                      Array.from({length:4}).map((_,i)=><div key={i} className="app-user">
                      <img src={require("../../assets/images/footer/model_1.jpg")} alt={'model'}  onError={({currentTarget},imageSize='55X55')=>showDummyImage({currentTarget},imageSize)}/>
                    </div>)
                    }
                    <div className="more-user-icon">
                      <AiOutlinePlus />
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-top-content-item">
                <div className="download-by">
                  <div className="download-options">
                    <div className="download-option">
                      <div className="download-option-logo">
                        <img src={require("../../assets/images/footer/google_play.png")} alt='googlePlay' onError={({currentTarget},imageSize='36X36')=>showDummyImage({currentTarget},imageSize)} />
                      </div>
                      <StarRating  value={4.2}/>
                      <small>4.2/5</small>
                    </div>
                    <div className="download-option">
                      <div className="download-option-logo">
                        <img src={require("../../assets/images/footer/apple_store.png")} alt='appleStore' onError={({currentTarget},imageSize='36X36')=>showDummyImage({currentTarget},imageSize)} />
                      </div>
                      <StarRating value={4.5}/>
                      <small>4.5/5</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-wrapper">
            <div className="footer-bottom-items">
              <div className="footer-bottom-item">
                <div className="footer-logo">
                  <Link to={"/"} className="logo">
                    <div className="logo-icon">
                      <GiStarShuriken />
                    </div>
                    <span>NFTs</span>
                  </Link>
                </div>
                <div className="community">
                  <h6>Join NFTs Community</h6>
                  <ul>
                    <li>
                      <Link to={"#"} className="community-link" onClick={()=>openInNewTab("https://www.google.com/")}>
                        <AiOutlineGoogle />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="community-link" onClick={()=>openInNewTab("https://twitter.com/")}>
                        <BsTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="community-link" onClick={()=>openInNewTab("https://www.instagram.com/")}>
                        <RiInstagramFill />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="community-link" onClick={()=>openInNewTab("https://www.linkedin.com/")}>
                        <BsLinkedin />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="community-link"onClick={()=>openInNewTab("https://www.youtube.com/")}>
                        <BsYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer-bottom-item">
                <div className="footer-nav">
                  <h6>Marketplaces</h6>
                  <ul className="footer-nav-links">
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        All NFTs
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        Solana NFTs
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        Art Work
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        Collectibles
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer-bottom-item">
                <div className="footer-nav">
                  <h6>Marketplaces</h6>
                  <ul className="footer-nav-links">
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                       About
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        RARI Token
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"} className="footer-nav-link">
                        Suggest Features
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>&copy;2022 NFTs @ All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
